module.exports = __webpack_public_path__ + "img/yano_Q_400_15_2.d0a4726c.png";